import script from "./StaffBookingsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffBookingsWidget.vue?vue&type=script&setup=true&lang=js"

import "./StaffBookingsWidget.vue?vue&type=style&index=0&id=3023088f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3023088f"]])

export default __exports__